const baseJson = () => {
    return {
        id: null,
        userName: null,
        lastName: null,
        firstName: null,
        address: null,
        donVi: null,
        chucVu: null,
        phoneNumber: null,
        email: null
    }
}

export const thongTinLienLacModel = {
    baseJson
}
